import { useState, useEffect } from 'react'
import * as Util from '../data/General';

const timer = 30200;
const countPage = 30;
export const FILTER = {
  "unread": "unread=true",
  "read": "unread=false",
  "all": "",
  "tickets": "humanRequest=true",
  "REVIEW": "type=REVIEW",
  "MARKETING": "type=MARKETING",
  "NOTIFICATION": "type=NOTIFICATION",
  "CHAT": "type=CHAT",
  "CHATBOT": "type=CHATBOT"
}

export const FILTER_SERACH = {
  "REVIEW": "type=REVIEW",
  "MARKETING": "type=MARKETING",
  "NOTIFICATION": "type=NOTIFICATION",
  "CHAT": "type=CHAT",
  "CHATBOT": "type=CHATBOT"
}
export function useMessages ({ callback = null, body = null, method="POST", server="inboxs/conversations", filterDefault="all"}) {
  const [data, setData] = useState(null);
  const [url, setURL] = useState(`?from=0&size=${countPage}&sortBy=updated_at&sortOrder=desc${filterDefault !== "" ? `&${FILTER[filterDefault]}` : ''}`);
  const [isLoad, setIsLoad] = useState(false);
  const [count, setCount] = useState(countPage);
  const [text, setText] = useState('');
  const [filter, setFilter] = useState(filterDefault);
  const [check, setCheck] = useState({});
  

  const searchText = (t) => {
    setText(t);
    refreshUrl(t, count);
  }

  const setNewFilter = (f) => {
    setFilter(f);
    refreshUrl(text, count, f);
  }

  const refreshUrl = (t, c, f=filter) => {
    let newUrl="";
    if(FILTER_SERACH[f]){
      newUrl =`/messages?from=0&size=${c}&sortBy=created_at&sortOrder=desc`;
    }else if(t === ""){
      newUrl =`?from=0&size=${c}&sortBy=created_at&sortOrder=desc`;
    }else{
      newUrl =`/messages?text=${t}&from=0&size=${c}&sortBy=created_at&sortOrder=desc`;
    }
    newUrl = newUrl + ((f !== "" && FILTER[f]) ? `&${FILTER[f]}` : '');
    setURL(newUrl);
  }

  const incrementPage = (add=countPage) => {
    setCount(count + add);
    refreshUrl(text, count + add);
  }

  const refreshData = () => {
    if(url !== ""){
      setIsLoad(true);
      clearTimeout(window.intervalMessage); 
      Util.callServer(dataOk, dataFail, `${server}${url}`,body, method);
    }
  }
  const dataOk = (data) => {
    setCheck({});
    setData(data);
    if(callback) {
      callback(data);
    }
    setIsLoad(false);
    window.intervalMessage = setTimeout(function(){refreshData();}.bind(this), timer); 
  }
  const dataFail = (data) => {
    console.log(data);
  }
  

  // para recuperar la cita al cargar la página
  useEffect(() => {
    refreshData()
  }, [url])


  const clear = () => {
    clearTimeout(window.intervalMessage);  
    setURL("");
  }
  const setInbox = (i) => {
    let copyCheck = {...check};
    copyCheck[i] = true;
    setCheck(copyCheck);
  }
  const isInbox = (item) =>{
    return (item.inbox && item.inbox > 0 && !check.hasOwnProperty(item.id))
  }

  return { data, isLoad, searchText, incrementPage, clear, setNewFilter, filter, setInbox, isInbox, refreshData }
}
